import React from 'react'
import { Button, ButtonProps } from './Button'
import { LoadingSpinner } from '../LoadingSpinner'

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean
  loadingText?: string
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading = false,
  loadingText,
  children,
  disabled,
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={isLoading || disabled}
      className={props.className}
    >
      {isLoading && (
        <LoadingSpinner size="sm" className="mr-2" />
      )}
      {isLoading ? (loadingText || 'Loading...') : children}
    </Button>
  )
}